jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
//navigation script code 
 
  // Get all elements with class "parenttab-span"
  let tablinks = $(".parenttab-span");

  // Get all elements with class "child-ul"
  let tabcontents = $(".child-ul");

tablinks.each(function(index, tablink) {
  $(tablink).on("click", function() {
    // Remove the "active" class from all tablinks
    tablinks.removeClass("myactive");

    // Hide all tabcontent elements and remove "active" class
    tabcontents.hide().removeClass("activee");

    // Display the tabcontent for the clicked tablink and add "active" class
    $(tabcontents[index]).show().addClass("activee");

    // Add the "active" class to the clicked tablink
    $(tablink).addClass("myactive");
  });
});

  
//navigation menu link with slider

  $('.parent-Women').on('click', function() {
    $('.category__button.category_women').click();
  });

  $('.parent-Kids').on('click', function() {
    $('.category__button.category_kids').click();
  });

  $('.parent-Men').on('click', function() {
    $('.category__button.category_mens').click();
  });



    
//currency converter code
   $(document).ready(function() {
     $('.currency-list li').on('click', function(event) {
         $('.currency-list').css('display', 'none');
         var currList = $('.curr-list');
        currList.removeClass('is--opend');
     });
 }); 



 
  $(document).ready(function() {
    $('#trackByEmail').on('submit', function(event) {
    	event.preventDefault();
      const data = new FormData(this);
      const formJSON = Object.fromEntries(data.entries());
      var datsJSON = JSON.stringify( formJSON );
      console.log(data);
      console.log(datsJSON);
      console.log(formJSON);
      $('.loading-modal').show();
      $.ajax({
        url: 'https://unified-tracking-backend.alchemative.net/track_by_order_name',
        type: 'POST',
        headers: {'Authorization': 'Bearer e42fa59d7063e9870e4272b660f61112fd8296d8'},
        data: datsJSON,
        contentType: 'application/json',
        dataType: 'json',
        success: function(response)
        {
          console.log(response);
          emptyTable();
          orderItem(response.line_items);
          orderStatus(response.tracking_history,response.details.order_name);
          $('.loading-modal').hide();
        },
        error: function(response)
        {
          console.log(response);
          $('.loading-modal').hide();
          $('#myModal').show();
        }
      });
    });
    $('#trackByCN').on('submit', function(event) {
    	event.preventDefault();
      const data = new FormData(this);
      const formJSON = Object.fromEntries(data.entries());
      var datsJSON = JSON.stringify( formJSON );
      console.log(data);
      console.log(datsJSON);
      $('.loading-modal').show();
      $.ajax({
        url: 'https://unified-tracking-backend.alchemative.net/track_by_cn',
        type: 'POST',
        headers: {'Authorization': 'Bearer e42fa59d7063e9870e4272b660f61112fd8296d8'},
        data: datsJSON,
        contentType: 'application/json',
        dataType: 'json',
        success: function(response)
        {
          console.log("Track by cn",response);
          emptyTable();
          orderItem(response.line_items);
          orderStatus(response.tracking_history,response.order_name.split('.')[0]);
          $('.loading-modal').hide();
        },
        error: function(response)
        {
          console.log(response);
          $('.loading-modal').hide();
          $('#myModal').show();
        }
      });
    });
    function orderItem(items)
    {
      if(items !== null) {
        var itemsTableData = '';
        items.forEach(function(itemsData) {
          itemsTableData += '<tr>';
          itemsTableData += '<td>' + itemsData.product_title + '</td><td>' + itemsData.qty + '</td><td>' + itemsData.sku + '</td>';
          itemsTableData += '</tr>';
        });
        $('#order_items_tbody').append(itemsTableData);
        console.log(itemsTableData);
      }
    }
    function orderStatus(status,order_name)
    {document.getElementById('order-name').innerHTML=""
      console.log(status);
      if(status !== null) {
        var statusTableData = '';
        status.forEach(function(statusData) {
          statusTableData += '<tr>';
          statusTableData += '<td>' + statusData.date + '</td><td>' + statusData.status + '</td>';
          statusTableData += '</tr>';
        });
        document.getElementById('order-name').innerHTML="Order Name"+' '+order_name
        $('#order_status_tbody').append(statusTableData);
        console.log(statusTableData);
      }
    }
    $('[data-dismiss=modal]','#myModal').click(function(){
      $('#myModal').hide()
    })
    function emptyTable()
    {
          $('#order_status_tbody').empty();
          $('#order_items_tbody').empty();
          $('.tracking-form--wrap').hide();
          $('.order-status--wrap').show();
    }
    $('.resetTalbeRecord').click(function() {
      	$('#order_status_tbody').empty();
        $('#order_items_tbody').empty();
        $('.tracking-form--wrap').css('display', 'flex');
      	$('.order-status--wrap').hide();
    });
  });

});

 
